export const sliderResponsive = [
  { breakpoint: 481, settings: { slidesToShow: 2, slidesToScroll: 1 } },
  { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
  { breakpoint: 1250, settings: { slidesToShow: 4, slidesToScroll: 1 } },
];
